import { AxiosError } from 'axios';
import { useCallback, useEffect, useState } from 'react';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { subscriptionActions } from '../../../redux/slices/subscriptionSlice';
import { BillingHistoryItem } from '../../../redux/slices/subscriptionSlice';
import { useAppDisPatch, useAppSelector } from '../../../redux/store';
import useHttps from '../../useHttps';

const useGetBillingHistory = () => {
  const request = useHttps();
  const dispatch = useAppDisPatch();
  const { authData } = useAppSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const getBillingHistory = useCallback(() => {
    const url: HttpConfig = {
      url: 'auth-service/subscriptions/me/history',
      method: 'get',
    };
    setError(null);
    return request(url, (response: unknown) => {
      const data = (response as SuccessHttpResponse<BillingHistoryItem[]>).data;
      dispatch(subscriptionActions.setBillingHistory(data));
    }, setLoading, (err: AxiosError<ErrorHttpResponse>) => {
      console.error('Error fetching billing history:', err?.message);
      setError(err?.response?.data?.message ?? 'Unable to load transactions right now.');
    });
  }, [request, dispatch]);

  useEffect(() => {
    if (authData) {
      getBillingHistory();
    }
  }, [authData, getBillingHistory]);

  return { getBillingHistory, loading, error };
};

export default useGetBillingHistory;
